<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="9">
                    <h3>Relatório - Quantidade total de usuários por tipo</h3>
                 </b-col>
                 <b-col md="3">
                    <p><b>Nome:</b> {{usuario.nome}}</p>
                    <p><b>Perfil:</b> {{this.usuario.perfil.nome}}</p>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col sm="4">
                     <b-form-group label="UF:">
                        <b-form-select v-model="filtros.uf" :options="estados" class="mb-3">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group label="Município:" :disabled="disabled_cidades">
                        <b-form-select
                                v-model="filtros.municipio"
                                :options="cidades">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="2">
                <b-button @click="pesquisar()" block variant="primary">
                    <span>Pesquisar</span>
                </b-button>
                </b-col>
            </b-row>
            <br>
        </b-card-body>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                    <b-card header="Resultado"  body-class="text-center">
                      <b-card-text>Administradores: <b>{{ this.adminitradores }}</b></b-card-text>
                      <br>
                      <b-card-text>Visualizadores: <b>{{ this.visualizadores }}</b></b-card-text>
                      <br>
                      <b-card-text>Gestores: <b>{{ this.gestores }}</b></b-card-text>
                      <br>
                      <b-card-text>Tutores: <b>{{ this.tutores }}</b></b-card-text>
                      <br>
                      <b-card-text>Beneficiárias: <b>{{ this.beneficiarias }}</b></b-card-text>
                      <br>
                      <b-card-text>Voluntárias: <b>{{ this.voluntarias }}</b></b-card-text>
                    </b-card>
                </b-container>
            </b-col>
        </b-row>
        <b-card-footer>
          <b-row>
            <b-col md="3">
              <span v-if="btnExpotar">
                    <b-button block variant="primary" @click="exportar">
                      <i class="fa fa-file"></i>&nbsp;&nbsp;<span>Exportar para Excel</span>
                    </b-button>
                  </span>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/PaginationRelatorio'
import {eventType} from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'
import miniToastr from 'mini-toastr'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

miniToastr.init()

Vue.component('multiselect', Multiselect)

export default {
  components: {
    Pagination
  },
  created () {
    this.$store.dispatch('buscarEstados3')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      beneficiarias: 0,
      voluntarias: 0,
      adminitradores: 0,
      visualizadores: 0,
      gestores: 0,
      tutores: 0,
      beneficiarias_vinculadas: 0,
      totalRegistros: 0,
      btnExpotar: false,
      disabled_cidades: true,
      perfilAdmin: false,
      modalPreExcluir: false,
      totalPorPagina: 5,
      resource: 'usuario/relatorio-usuario-idade',
      filtros: {
        uf: null,
        municipio: null,
        paginacao: 10
      },
      listaPagination: [
        { value: 5, text: '5', selected: false},
        { value: 10, text: '10', selected: true},
        { value: 20, text: '20', selected: false},
        { value: 30, text: '30', selected: false},
        { value: 40, text: '40', selected: false},
        { value: 50, text: '50', selected: false},
        { value: 100, text: '100', selected: false }
      ],
      select: {
        selected: '10',
        options: [
          '5',
          '10',
          '15',
          '20',
          '30',
          '40',
          '50',
          '100'
        ]
      }
    }
  },
  computed: {
    usuarios () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  watch: {
    'beneficiarias': function () {
      if (this.beneficiarias === 0 && this.voluntarias === 0) {
        this.btnExpotar = false
      } else {
        this.btnExpotar = true
      }
    },
    'filtros.uf': function () {
      if (this.filtros.uf !== null) {
        this.$store.dispatch('buscarCidadesPorEstado2', this.filtros.uf)
        this.disabled_cidades = false
        this.filtros.municipio = null
      } else {
        this.disabled_cidades = true
        this.filtros.municipio = null
      }
    }
  },
  methods: {
    exportar () {
      Vue.http.get('api/usuario/relatorio-usuario-total-excel', {params: this.filtros}).then(response => {
        if (response.body.success) {
          let url = process.env.ROOT_API1 + 'documentos/' + response.body.data.filename
          
          window.location.href = url
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    situacao (situacao) {
      var descricao = ''
      if (situacao !== null) {
        switch (situacao) {
          case 'AT':
            descricao = 'Ativo'
            break
          case 'SU':
            descricao = 'Suspenso'
            break
          case 'PP':
            descricao = 'Pendente de Ativação'
            break
          case 'PA':
            descricao = 'Pendente de Ativação'
            break
          case 'RJ':
            descricao = 'Rejeitado'
            break
        }
        return descricao
      }
    },
    situacaoSocial (obj) {
      if (obj !== null) {
        let situacao = JSON.parse(obj)
        return situacao[0].name
      } else {
        return ''
      }
    },
    dataNascimento (data) {
      if (data !== null) {
        return moment(String(data), 'YYYY-MM-DD').format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    idade (data) {
      if (data !== null) {
        let m = moment(data, 'YYYY-MM-DD')
        let years = moment().diff(m, 'years', false)
        return years
      } else {
        return ''
      }
    },
    pesquisar () {
      Vue.http.get('api/usuario/relatorio-usuario-total', {params: this.filtros}).then(response => {
        if (response.body.success) {
          let dados = response.body.data.data
          this.beneficiarias = dados.beneficiarias
          this.voluntarias = dados.voluntarias
          this.adminitradores = dados.adminitradores
          this.visualizadores = dados.visualizadores
          this.gestores = dados.gestores
          this.tutores = dados.tutores
        } else {
          this.beneficiarias = 0
          this.voluntarias = 0
          this.adminitradores = 0
          this.visualizadores = 0
          this.gestores = 0
          this.tutores = 0
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    navigate (route) {
      this.$router.push(route)
    },
    editarLocal (id) {
      this.$router.push('/local/' + id + '/editar')
    }
  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/relatorios/UsuarioTotal.vue